import React from 'react';

/** Évite l'écran noir total si un sous-composant réparations plante. */
export default class RepairViewErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[Reparations]', error, info);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="p-6 rounded-xl border border-red-500/30 bg-red-950/20 text-red-200 text-sm max-w-lg mx-auto mt-8">
          <p className="font-bold mb-2">Impossible d&apos;afficher les réparations</p>
          <p className="text-xs opacity-80 break-words">{String(error?.message || error)}</p>
          <button
            type="button"
            className="mt-4 px-4 py-2 rounded-lg bg-white/10 hover:bg-white/15 text-white text-sm font-medium"
            onClick={() => this.setState({ error: null })}
          >
            Réessayer
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
